import React, { lazy } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import RoleRestrictedRoute from 'utility/routing/RoleRestrictedRoute';
import { roles } from 'utility/constants/roles';
import DomainDetailsLayout from 'components/standard/DomainDetailsLayout';

const Domains = lazy(() => import('containers/pages/domains/Domains'));

const DnsZones = lazy(() => import('containers/pages/domains/dns'));

const Ssls = lazy(() => import('containers/pages/domains/Ssls'));

const DomainDetails = lazy(() => import('containers/pages/domains/details'));

const DomainRegistration = lazy(
	() =>
		import('containers/pages/domains/details/registration/DomainRegistration'),
);

const DomainDNS = lazy(
	() => import('containers/pages/domains/details/dns/DomainDNS'),
);

const SslDetails = lazy(
	() => import('containers/pages/domains/details/SslDetails'),
);

const CreateDNSZone = lazy(
	() => import('containers/pages/domains/details/dns/CreateDNSZone'),
);

const ReverseDns = lazy(() => import('containers/pages/domains/ReverseDns'));

const CreateTransfer = lazy(
	() => import('containers/pages/domains/CreateTransfer'),
);

const Cloudflare = lazy(() => import('containers/pages/domains/Cloudflare'));

const CloudflareDetails = lazy(
	() => import('containers/pages/domains/Cloudflare/Details'),
);
const NotFound = lazy(() => import('pages/error/NotFound'));

const DomainsRouter = () => {
	return (
		<Switch>
			<RoleRestrictedRoute
				exact
				path="/domain"
				component={Domains}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				exact
				path="/domain/dns"
				component={DnsZones}
				whitelistedRoles={[roles.PURCHASER]}
			/>
			<RoleRestrictedRoute
				exact
				path="/domain/create-transfer"
				component={CreateTransfer}
				whitelistedRoles={[roles.PURCHASER]}
			/>
			<RoleRestrictedRoute
				path="/domain/dashboard/:domain"
				component={DomainDetails}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				path="/domain/registration/:domain"
				component={DomainRegistration}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				exact
				path="/domain/ssl"
				component={Ssls}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				exact
				path="/domain/ssl/dashboard/:domain"
				component={({ match }) => (
					<Redirect to={`/domain/${match.params.domain}/ssl`} />
				)}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				path="/domain/dns/add"
				component={CreateDNSZone}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				path="/domain/ssl/add"
				component={() => (
					<Redirect to={{ pathname: '/domain/ssl', search: '?add=true' }} />
				)}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				path="/domain/dns/reverse-dns/:uniqId?"
				component={ReverseDns}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>

			<RoleRestrictedRoute
				path="/domain/dns/:domain"
				component={DomainDNS}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				exact
				path="/domain/cloudflare"
				component={Cloudflare}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				path="/domain/cloudflare/:uniqId"
				component={CloudflareDetails}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<Route path="/domain/:domain">
				<DomainDetailsLayout>
					<Switch>
						{/* TODO DEV-6088 add domain registration and dns pages here */}

						<RoleRestrictedRoute
							path="/domain/:domain/ssl"
							component={SslDetails}
							whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
						/>
					</Switch>
				</DomainDetailsLayout>
			</Route>

			<Route>
				<NotFound />
			</Route>
		</Switch>
	);
};

export default DomainsRouter;
